import Vue from 'vue'
import { SEX_TYPE, getLabelByValue } from './constant'
import { ID_CARD_REG } from './validator'

Vue.filter('formatDate', (val, format = 'yyyy-MM-dd') => {
  if (!val) return ''
  return new Date(val).format(format)
})

Vue.filter('formatSex', val => {
  if (!val) return ''
  return getLabelByValue(val, SEX_TYPE)
})

Vue.filter('formatDiplomaPhoto', val => {
  if (!val) return ''
  return `${process.env.VUE_APP_STATIC_HOST}${val}!image.editor.cert`
})

Vue.filter('formatIdSeriesNo', val => {
  if (!val) return ''
  return val.replace(ID_CARD_REG, '$1********$5')
})
